import React from "react";
// import serviceshero from "../../images/serviceshero.jpg";
import { useOutletContext, useParams, Link } from "react-router-dom";
import logo from "../../images/logo.png";

import "./blog.css";
import { Helmet } from "react-helmet-async";

function BlogPost() {
  const { posts, loading } = useOutletContext();
  const { postId, slug } = useParams();

  if (loading) {
    return null;
  }
  const post = posts.find((post) => post._id === postId);

  const description = post.body
    .replace(/<[^>]*>/g, "") // Remove any HTML tags
    .slice(0, 200) // Get first 200 characters
    .concat(post.body.length > 200 ? "..." : "");

  const date = new Date(post.createdAt).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="px-2">
      <Helmet>
        {/* Title and Meta Description */}
        <title>{post.title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={description} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={description} />
        <meta
          property="og:url"
          content={`https://www.brookshealthandcare.com/blog/${postId}/post/${slug}`}
        />
        <meta property="og:image" content={post.uri || logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          position: "relative", // Needed for positioning the overlay
          width: "100%",
          backgroundImage: `url(${post.uri || logo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)", // Semi-transparent black overlay
            zIndex: 1, // To ensure it stays behind text
          }}
        />
        <div
          className="aboutheroreplacementbox"
          style={{ position: "relative", zIndex: 2 }}
        >
          {" "}
          {/* Adjust zIndex to bring text above overlay */}
          <div className="lhsheading">
            <span className="thick-dot"></span>
            <span className="ps-1">{date}</span>
          </div>
          <div className="lhssubtitle pb-1 pt-3">{post.title}</div>
        </div>
      </div>

      <div className="p-2 text-center">
        {/* <div className="blogpageheading">{post.title}</div> */}
        <div
          className="blogpageparagraph pt-2 pt-md-5"
          // style={{
          //   textAlign: "left", // Align text to the left
          //   width: "90%", // Ensure the paragraph takes up the full width
          //   maxWidth: "800px", // Adjust the max-width
          //   margin: "0 auto", // Center the paragraph in the container
          //   lineHeight: "1.4", // Improve readability
          // }}
          dangerouslySetInnerHTML={{ __html: post.body }}
        ></div>

        <div className="d-flex justify-content-center py-5">
          <Link to="/blog">
            <button
              type="button"
              className="testimonialbtn mx-2" // Same class for styling
              style={{
                minWidth: "8rem",
                display: "flex",
                justifyContent: "center", // Center the text inside
                opacity: "1", // No disabled effect
              }}
            >
              <span
                className="text-white"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center", // Center the text
                  alignItems: "center",
                }}
              >
                View All Posts
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
export default BlogPost;
